export default "__VITE_ASSET__BM_f3n46__"